<template>
    <div>
        <b-row :class="comp_classes" class="btn-row">
            <b-col 
                v-for="(b,i) in buttons" :key="i" :cols="b.width == 'full' ? 12 : cols" :style="b.width == 'full' ? '' : b.style">
                <application v-if="b.to == 'application'" :agenda="b.data.agenda" :event_id="b.data.event_id"></application>
                <b-btn v-else :variant="b.variant" class="btn-block" :to="b.to" :type="b.type ? b.type : 'button'" :exact="true">
                    <span :class="b.icons ? 'd-flex align-items-center justify-content-between' : ''">
                        <span v-if="b.icons.left"><font-awesome-icon v-if="b.icons && b.icons.left && b.icons.left.visible || b.icons.right.visible" :icon="b.icons.left.icon" :class="b.icons.right.visible ? 'invisible' : ''" /></span>
                        {{ b.title }}
                        <span v-if="b.icons.left"><font-awesome-icon v-if="b.icons && b.icons.right && b.icons.left.visible || b.icons.right.visible" :icon="b.icons.right.icon" :class="b.icons.left.visible ? 'invisible' : ''" /></span>
                    </span>
                </b-btn>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import ApplicationVue from './Application.vue';
export default {
    name: 'button-row',
    components: {
        'application': ApplicationVue
    },
    props: {
        Buttons: {
            type: Array
        },
        comp_class: {
            type: String
        }
    },
    computed: {
        comp_classes() {
            return this.comp_class ? this.comp_class : 'pb-4';
        },
        buttons() {
            const buttons = this.Buttons.map((button, i) => {
                button.width = this.Buttons.length > 1 ? 'custom' : 'full';
                button.style = i == 0 ? 'padding-right:7px;' : 'padding-left:8px;';
                if (i > 0 && i < this.Buttons.length) {
                    button.style += 'padding-right: 7px';
                }
                return button;
            }); 
            return buttons;
        },
        cols() {
            const count_buttons = this.Buttons.length;
            return 12 / count_buttons;
        }
    }
}
</script>

<style lang="scss">
@import '../scss/variables';
.btn-row {
    .btn {
        font-size: 14px;
        font-weight: $font-weight-bold;
        padding-top: 14px;
        padding-bottom: 13px;
    
        &-light {
            color: $primary;
        }
    }
}
</style>